// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-quill .ql-toolbar {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.d2-quill .ql-container {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}", ""]);
// Exports
module.exports = exports;
